import React, { FC, useState, useEffect, useContext, useRef } from 'react'
import moment from 'moment'
import {
  StackedCarousel,
  StackedCarouselSlideProps,
  ResponsiveContainer,
} from 'react-stacked-center-carousel'
import { Modal } from 'react-responsive-modal'
import { isMobile } from 'react-device-detect'

import { getSingleFeed, deleteFeed } from '../../../Api/backendApi'

import AppContext from '../../../context/appContext'

import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericButton from '../../../GenericComponents/GenericButton'

import {
  CarouselImageBox,
  CardBox,
  Card,
  ArrowButton,
} from '../style/ProgressScreenStyle'

import RemoveProgressModal from './RemoveProgressModal'

import EditProgress from '../../../assets/REDESIGN_Assets/Progress/edit-progress.svg'
import RemoveProgress from '../../../assets/REDESIGN_Assets/Progress/remove-progress.svg'
import CompareProgress from '../../../assets/REDESIGN_Assets/Progress/compare-progress.svg'
import GenericColumn from '../../../GenericComponents/GenericColumn'

import OutlineFront from '../../../assets/REDESIGN_Assets/UserWizzard/woman_front_outline.png'
import OutlineBack from '../../../assets/REDESIGN_Assets/UserWizzard/woman_back_outline.png'
import OutlineSide from '../../../assets/REDESIGN_Assets/UserWizzard/woman_side_outline.png'

interface EntryShowcaseInterface {
  clickedFeedData: any
  oldestFeedWithPhotos: any
  handleGoToCompare: Function
  handleGoToMainPage: Function
  getActivePhoto: Function
}

const EntryShowcase: FC<EntryShowcaseInterface> = ({
  clickedFeedData,
  oldestFeedWithPhotos,
  handleGoToCompare,
  handleGoToMainPage,
  getActivePhoto,
}) => {
  const [singleFeed, setSingleFeed] = useState(Object)
  const [card, setCard] = useState(null)
  const [canCompareEntries, setCanCompareEntries] = useState(false)
  const carouselReference: any = useRef()
  const [isModalOpen, setModalOpen] = useState(false)
  const [activePhoto, setActivePhoto] = useState('F')

  // 0 is Front, 1 is

  const modalStyles = {
    closeButton: {
      display: 'none',
    },
    modal: {
      maxWidth: 'unset',
      width: isMobile ? '95vw' : '55vw',
      overflow: 'unset',
      left: '0',
      boxsizing: 'border-box',
      margin: isMobile ? 'auto' : 'unset',
      borderRadius: '30px',
    },
  }

  useEffect(() => {
    if (oldestFeedWithPhotos !== null) {
      if (
        oldestFeedWithPhotos.photos &&
        oldestFeedWithPhotos.photos.length &&
        oldestFeedWithPhotos.photos.length === 3 &&
        clickedFeedData.images &&
        clickedFeedData.images.length &&
        clickedFeedData.images.length == 3
      ) {
        oldestFeedWithPhotos.creation_datetime < clickedFeedData.date
          ? setCanCompareEntries(true)
          : setCanCompareEntries(false)
      }
    } else {
      setCanCompareEntries(false)
    }
    // if (
    //   oldestFeedWithPhotos &&
    //   oldestFeedWithPhotos.photos.length &&
    //   clickedFeedData &&
    //   clickedFeedData.photos.length
    // ) {
    //   oldestFeedWithPhotos.creation_datetime < clickedFeedData.creation_datetime
    //     ? setCanCompareEntries(true)
    //     : setCanCompareEntries(false)
    // }
  }, [oldestFeedWithPhotos])

  const handleActivePhoto = (activeIndex: number) => {
    // dataIndex:
    // bok - 2
    // przod - 0
    // tyl -1

    switch (activeIndex) {
      case 2:
        setActivePhoto('S')
        getActivePhoto('S')
        break
      case 0:
        setActivePhoto('F')
        getActivePhoto('F')
        break
      case 1:
        setActivePhoto('B')
        getActivePhoto('B')
        break
      default:
        break
    }
  }

  const gatherBackground = (type: string) => {
    // let imageUrl

    let imageUrl = clickedFeedData.images.filter(
      (image: any) => image.type == type && image.url
    )

    return imageUrl[0]
  }

  gatherBackground('F')
  const data = [
    {
      url:
        clickedFeedData &&
        clickedFeedData.images.length &&
        gatherBackground('F')
          ? gatherBackground('F').url
          : OutlineFront,
      title: 'image1',
    },
    {
      url:
        clickedFeedData &&
        clickedFeedData.images.length &&
        gatherBackground('B')
          ? gatherBackground('B').url
          : OutlineBack,
      title: 'image2',
    },
    {
      url:
        clickedFeedData &&
        clickedFeedData.images.length &&
        gatherBackground('S')
          ? gatherBackground('S').url
          : OutlineSide,
      title: 'image3',
    },
  ]

  const onCardChange = (event: any) => {}
  const appContext = useContext(AppContext)

  const obtainSingleFeed = async () => {
    let feed

    if (clickedFeedData && clickedFeedData.id) {
      feed = await getSingleFeed(clickedFeedData.id)
      setSingleFeed(feed)
    }
  }

  useEffect(() => {
    obtainSingleFeed()
  }, [])

  const Slide = React.memo((props: StackedCarouselSlideProps) => {
    const { data, dataIndex } = props

    if (props.isCenterSlide) {
      handleActivePhoto(props.dataIndex)
    }
    // dataindex:
    // bok - 2
    // przod - 0
    // tyl -1

    return (
      <Card
        style={{
          width: '33%',
          height: window.innerHeight * 0.35,
          userSelect: 'none',
        }}
      >
        <img
          style={{
            height: '100%',
            width: '100%',
            objectFit: 'contain',
            borderRadius: 19,
          }}
          draggable={false}
          src={data[dataIndex].url}
        />
      </Card>
    )
  })

  return (
    <GenericMainCard
      width={isMobile ? '95%' : '60%'}
      flexDir={'column'}
      className="standard"
      margin={isMobile ? '0% auto 0 auto' : '5% auto 0 auto'}
    >
      <GenericRow>
        <GenericTextSpan margin={isMobile ? '5% 0' : 'unset'} fSize={'1.8rem'}>
          Twoje postępy
        </GenericTextSpan>
      </GenericRow>

      <GenericRow
        margin={'4% 0 0 0'}
        justify={isMobile ? 'space-between' : 'center'}
      >
        <GenericRow width={isMobile ? '50%' : '30%'}>
          <GenericTextSpan fSize={isMobile ? '1rem' : '1.4rem'}>
            {moment(clickedFeedData.date).format('DD MMMM YYYY')}
          </GenericTextSpan>
        </GenericRow>

        <GenericRow width={'30%'} elign="center">
          {/* {moment(clickedFeedData.date).isSame(moment(), 'day') && (
            <GenericIcon
              className="button-style"
              margin={'0 9% 0 0'}
              src={EditProgress}
              width={isMobile ? '6vw' : '1.5vw'}
              height={isMobile ? '6vw' : '1.5vw'}
            />
          )} */}
          {canCompareEntries && (
            <GenericIcon
              className="button-style"
              margin={'0 9% 0 0'}
              src={CompareProgress}
              width={isMobile ? '6.5vw' : '1.8vw'}
              height={isMobile ? '6.5vw' : '1.8vw'}
              onClick={handleGoToCompare}
            />
          )}
          <GenericIcon
            src={RemoveProgress}
            onClick={() => setModalOpen(true)}
            className="button-style"
            width={isMobile ? '6vw' : '1.5vw'}
            height={isMobile ? '6vw' : '1.5vw'}
          />
        </GenericRow>
      </GenericRow>

      <GenericRow width={isMobile ? '75%' : '45%'} margin={'3% 0 0 0'}>
        <GenericColumn align={'flex-start'}>
          <GenericTextSpan
            fSize={isMobile ? '1rem' : '1.4rem'}
            fWeight={'bold'}
          >
            Brzuch
          </GenericTextSpan>
          <GenericTextSpan
            margin={'4% 0 0 0'}
            fSize={isMobile ? '0.85rem' : '1.2rem'}
          >
            {singleFeed && singleFeed.belly_circumference} cm
          </GenericTextSpan>
        </GenericColumn>
        <GenericColumn>
          <GenericTextSpan
            fSize={isMobile ? '1rem' : '1.4rem'}
            fWeight={'bold'}
          >
            Udo
          </GenericTextSpan>
          <GenericTextSpan
            margin={'4% 0 0 0'}
            fSize={isMobile ? '0.85rem' : '1.2rem'}
          >
            {singleFeed && singleFeed.thigh_circumference} cm
          </GenericTextSpan>
        </GenericColumn>
        <GenericColumn align={'flex-end'}>
          <GenericTextSpan
            fSize={isMobile ? '1rem' : '1.4rem'}
            fWeight={'bold'}
          >
            Biodra
          </GenericTextSpan>
          <GenericTextSpan
            margin={'4% 0 0 0'}
            fSize={isMobile ? '0.85rem' : '1.2rem'}
          >
            {singleFeed && singleFeed.hip_circumference} cm
          </GenericTextSpan>
        </GenericColumn>
      </GenericRow>

      <div
        className={'carousel-container'}
        style={{
          width: isMobile ? '150%' : '100%',
          position: 'relative',
          marginLeft: isMobile ? '59%' : '39%',
          marginTop: '3%',
          boxSizing: 'border-box',
        }}
      >
        <div onClick={() => carouselReference.current.goNext()}>
          <ArrowButton className="right"> {`>`} </ArrowButton>
        </div>
        <ResponsiveContainer
          carouselRef={carouselReference}
          render={(parentWidth, carouselRef) => {
            let currentVisibleSlide = 3
            if (parentWidth <= 1440) currentVisibleSlide = 3
            else if (parentWidth <= 1080) currentVisibleSlide = 1
            return (
              <StackedCarousel
                ref={carouselRef}
                data={data}
                // height={500}
                carouselWidth={parentWidth}
                slideWidth={window.innerWidth / (isMobile ? 1.1 : 2.5)}
                slideComponent={Slide}
                maxVisibleSlide={3}
                currentVisibleSlide={currentVisibleSlide}
                useGrabCursor={true}
              />
            )
          }}
        />

        <div onClick={() => carouselReference.current.goBack()}>
          <ArrowButton className="left"> {`<`}</ArrowButton>
        </div>
      </div>

      <Modal
        open={isModalOpen}
        animationDuration={700}
        onClose={() => setModalOpen(false)}
        center
        styles={modalStyles}
      >
        <RemoveProgressModal
          feedId={clickedFeedData && clickedFeedData.id}
          closeModal={() => setModalOpen(false)}
          handleGoToMainPage={handleGoToMainPage}
        />
      </Modal>
    </GenericMainCard>
  )
}

export default EntryShowcase
